import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';

// Set initial document direction based on saved locale
const initialLocale = localStorage.getItem('locale') || 'en';
document.documentElement.setAttribute('dir', initialLocale === 'ar' ? 'rtl' : 'ltr');
// Set initial document direction based on saved locale

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
